import { unsafeCSS } from 'lit'
import { property } from 'lit/decorators.js'

import { Spacing } from '@/common/types'
import { DdsElement } from '@/internal/dds-hu-element'

import styles from './_styles/divider.scss?inline'

/**
 * `dap-ds-divider`
 * @summary A divider is a visual separator between elements.
 * @element dap-ds-divider
 * @title - Divider
 *
 * @cssproperty --dds-divider-border-width - The width of the divider border. (default: var(--dds-border-width-base))
 * @cssproperty --dds-divider-border-style - The style of the divider border. (default: solid)
 * @cssproperty --dds-divider-border-color - The color of the divider border. (default: var(--dds-border-neutral-divider))
 * @cssproperty --dds-divider-border-color-inverted - The color of the divider border when inverted. (default: var(--dds-border-neutral-divider-inverted))
 */
export default class DapDSDivider extends DdsElement {
  static tagName = 'dap-ds-divider'

  /** Whether the divider is vertical */
  @property({ type: Boolean, reflect: true }) vertical = false

  /** The spacing of the divider
   * @type { 0 | 100 | 200 | 300 | 400 | 500 | 600 | 700 | 800 | 1000 | 1200 | 1400 | 1600 | 1800 | 2000 | 2400 | 3000 | 4000 | 5000 | 6000 }
   */
  @property({ type: Number }) spacing: Spacing = 0

  /** The variant of the divider
   * @type {'normal' | 'inverted'}
   */
  @property({ type: String, reflect: true }) variant: string = 'normal'

  static readonly styles = unsafeCSS(styles)

  connectedCallback() {
    super.connectedCallback()
    this.setAttribute('role', 'separator')
    this.setAttribute(
      'aria-orientation',
      this.vertical ? 'vertical' : 'horizontal',
    )
    this.setAttribute('variant', this.variant)
    this.setAttribute('aria-hidden', 'true')
    this.classList.add(`divider-spacing-${this.spacing}`)
  }
}
